package com.fireavert.units.shared.client

import com.fireavert.cache.client.Preferences

class AddRemoveDevicesContainerController(private val preferences: Preferences) {
    val isAdmin = preferences.isAdmin
}